import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { ClockIcon, UsersIcon, CalendarIcon } from 'lucide-react';
export const Urgency = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-754">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-755">
        Wacht niet te lang
      </h2>
      <div className="bg-red-50 p-6 rounded-lg mb-8 border-2 border-red-200" data-id="element-756">
        <div className="flex items-start" data-id="element-757">
          <UsersIcon className="w-10 h-10 text-red-600 mr-4 flex-shrink-0" data-id="element-758" />
          <div data-id="element-759">
            <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-760">
              Beperkte beschikbaarheid
            </h3>
            <p className="mb-4 leading-relaxed text-red-800" data-id="element-761">
              Maximum 15 nieuwe cliënten per maand: Voor de kwaliteit van onze
              persoonlijke begeleiding.
            </p>
            <p className="mb-4 leading-relaxed text-red-800" data-id="element-762">
              Wachtlijst groeit: Steeds meer mensen ontdekken deze methode.
            </p>
            <p className="text-red-800" data-id="element-763">
              Deze maand nog 4 plekken beschikbaar.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-6 mb-8" data-id="element-764">
        <div className="flex items-start" data-id="element-765">
          <div className="mr-4 flex-shrink-0" data-id="element-766">
            <ClockIcon className="w-8 h-8 text-amber-500" data-id="element-767" />
          </div>
          <div data-id="element-768">
            <h3 className="font-bold text-lg mb-2" data-id="element-769">De kosten van wachten</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-770">
              <li data-id="element-771">
                <strong data-id="element-772">Hoe langer je wacht, hoe dieper de patronen:</strong>{' '}
                Vroeg ingrijpen is veel effectiever
              </li>
              <li data-id="element-773">
                <strong data-id="element-774">Je hond lijdt elke dag:</strong> Elke dag stress is een
                dag te veel
              </li>
              <li data-id="element-775">
                <strong data-id="element-776">Jouw vrijheid:</strong> Elke week die voorbijgaat, is
                een dag met minder vrijheid voor jou
              </li>
            </ul>
            <p className="mt-3 leading-relaxed" data-id="element-777">
              Het probleem lost zichzelf niet op. Sterker nog, het wordt erger.
              Elk keer dat je verkeerd oefent, worden de patronen dieper. Wat nu
              nog in 3 maanden op te lossen is, kan volgend jaar een permanent
              probleem worden.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-amber-50 p-6 rounded-lg mb-6 border border-amber-200" data-id="element-778">
        <h3 className="text-lg font-bold text-amber-800 mb-3" data-id="element-779">
          Stel jezelf deze vragen:
        </h3>
        <ul className="space-y-3" data-id="element-780">
          <li className="flex items-start" data-id="element-781">
            <span className="font-bold text-amber-800 mr-2" data-id="element-782">•</span>
            <span data-id="element-783">
              Hoeveel stress ervaar jij en je hond elke dag door dit probleem?
            </span>
          </li>
          <li className="flex items-start" data-id="element-784">
            <span className="font-bold text-amber-800 mr-2" data-id="element-785">•</span>
            <span data-id="element-786">
              Wat kost het je aan spontane momenten, oppaskosten en
              relatiestress?
            </span>
          </li>
          <li className="flex items-start" data-id="element-787">
            <span className="font-bold text-amber-800 mr-2" data-id="element-788">•</span>
            <span data-id="element-789">
              Hoe zou je leven eruitzien als je hond over 3 maanden rustig
              alleen kon blijven?
            </span>
          </li>
          <li className="flex items-start" data-id="element-790">
            <span className="font-bold text-amber-800 mr-2" data-id="element-791">•</span>
            <span data-id="element-792">Wat is het waard om je vrijheid terug te krijgen?</span>
          </li>
        </ul>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-793">
        <FreeConsultLink onClick={openModal} data-id="element-794">
          Wacht niet langer - plan nu je gratis intake gesprek
        </FreeConsultLink>{' '}
        en zet de eerste stap naar vrijheid voor jou én je hond.
      </p>
    </section>;
};